import router from '@/app/router';
import { store } from '@/app/store';

export const getStore = () => router.app?.$store ?? store;
